var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-5 mx-0 no-gutter" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _vm.activateSpinner
            ? _c("spinner")
            : _c("email-sender-form", {
                attrs: { mode: _vm.mode, readonly: !_vm.isEditable },
                model: {
                  value: _vm.config,
                  callback: function ($$v) {
                    _vm.config = $$v
                  },
                  expression: "config",
                },
              }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-end no-gutter" },
            [
              _vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.switchMode("details")
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("common.cncl")))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.switchMode("edit")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-pencil" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("administration.edit"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.deleteEmailSender },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-trash" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("rights.delete")))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEditable && _vm.formType !== "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.editEmailSender },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "add"
                ? _c(
                    "b-button",
                    {
                      staticClass: "mx-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.addEmailSender },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }